import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AumicoCoreProvider } from '@modeso/aumico-lib-core-fe';
import { Observable, finalize } from 'rxjs';
import { environment } from '../../../../../../environments/environment';
import { FcpDataDTO } from '../helpers/export.helper';

@Injectable({ providedIn: 'root' })
export class ExportingService {
    private readonly exporting = 'exporting';
    private readonly fcpDocxPath = 'fcp';

    private readonly apiGatewayUrl: string;
    private readonly socketUrl: string;

    constructor(private readonly http: HttpClient, private readonly coreProvider: AumicoCoreProvider) {
        this.apiGatewayUrl = environment.modeso.apiGateway;
    }

    exportFcpData$(payload: FcpDataDTO): Observable<any> {
        const url = `${this.apiGatewayUrl}${this.exporting}/${this.fcpDocxPath}`;
        this.coreProvider.dispatchBlockingRequest('exportFcpData$');
        return this.http
            .post(url, { data: payload }, { responseType: 'blob', observe: 'body' })
            .pipe(finalize(() => this.coreProvider.dispatchBlockingRequestEnd('exportFcpData$')));
    }
}
